import React, { useState, useEffect } from "react";
import Checkbox from "components/checkbox";
import Card from "components/card";
import { fetchData, updateData } from "services/ApiFetching";
import TICKET_STATUSES from "../../constants/constants";

const Modal = ({ type, onClose, title, ticket, onUpdate }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    setSelectedOption(null);
    const loadOptions = async () => {
      if (type === "agent") {
        try {
          const users = await fetchData("users");
          const agents = users.filter((user) => user.role === "agent");
          const map = {};
          agents.forEach((user) => {
            map[user.id] = user.username;
          });

          setOptions(
            agents.map((user) => ({
              id: user.id,
              name: user.username,
            }))
          );
        } catch (error) {
          console.error("Failed to fetch agents:", error);
        }
      } else if (type === "status") {
        setOptions(
          TICKET_STATUSES.map((s) => ({
            id: s.label,
            name: s.label,
          }))
        );
      } else if (type === "priority") {
        setOptions([
          { id: "low", name: "Low" },
          { id: "medium", name: "Medium" },
          { id: "high", name: "High" },
          { id: "critical", name: "Critical" },
        ])
      }
    };
    loadOptions();
  }, [type]);

  const handleConfirm = async () => {
    if (!selectedOption || !ticket) return;

    const now = new Date().toISOString();
    const updatedTicket = {
      ...ticket,
      data: ticket.data ? { ...ticket.data } : {},
    };


    if (type === "status") {
      const newStatusValue = TICKET_STATUSES.find(
        (s) => s.label === selectedOption.id
      )?.value;

      updatedTicket.status = newStatusValue;
      updatedTicket.status = newStatusValue;
      if (!updatedTicket.data.status_history) {
        updatedTicket.data.status_history = [];
      }
      updatedTicket.data.status_history.push({
        status: newStatusValue,
        changed_by: localStorage.getItem("username"),
        changed_at: now,
      });
    } else if (type === "agent") {
      updatedTicket.assigned_to = selectedOption.id;
      updatedTicket.assigned_to_user = selectedOption.name;
      updatedTicket.data.assignment_history = [
        ...(ticket.data.assignment_history || []),
        {
          assigned_to: selectedOption.name,
          assigned_at: now,
        },
      ];
    } else if (type === "priority") {
      updatedTicket.priority = selectedOption.id;
      if (!updatedTicket.data.priority_history) {
        updatedTicket.data.priority_history = [];
      }
      updatedTicket.data.priority_history.push({
        priority: selectedOption.id,
        changed_by: localStorage.getItem("username"),
        changed_at: now,
      });
    }

    try {
      await updateData(`tickets/${ticket.id}`, {
        subject: updatedTicket.subject,
        description: updatedTicket.description,
        status: updatedTicket.status,
        assigned_to: updatedTicket.assigned_to,
        priority: updatedTicket.priority,
        data: updatedTicket.data,
      });

      onUpdate(updatedTicket);
      onClose();
    } catch (error) {
      console.error(`Failed to update ticket ${type}:`, error);
    }
  };


  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <Card>
        <div className="flex flex-col items-center justify-center p-4 w-[22vw] min-w-[350px]">
          <h2 className="text-xl font-bold text-navy-700 dark:text-white mb-4">
            {title}
          </h2>
          <div className="mb-4 w-full max-h-[250px] overflow-y-auto">
            {options.map((option) => (
              <div
                key={option.id}
                className="py-2 px-3 rounded dark:hover:bg-gray-700 cursor-pointer text-center flex items-start justify-start"
                onClick={() => setSelectedOption(option)}
              >
                <div className="flex items-center">
                  <Checkbox
                    checked={selectedOption?.id === option.id}
                    me="10px"
                  />
                  <p className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
                    {option.name}
                  </p>
                </div>
              </div>
            ))}
          </div>
          <div className="flex items-center justify-between w-full">
            <button
              onClick={handleConfirm}
              className="px-4 py-2 mr-2 bg-brand-500 text-white rounded-lg hover:bg-brand-600 transition-colors"
            >
              Confirm
            </button>
            <button
              onClick={onClose}
              className="px-4 py-2 ml-2 bg-red-500 text-white rounded-lg hover:bg-red-700 transition-colors"
            >
              Cancel
            </button>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default Modal;
